module.exports = __webpack_public_path__ + "img/brand-icon.22336ddb.png";